import React from 'react';
import { MenuAlt2Icon } from '@heroicons/react/outline';
import RoleViewMenu from './RoleViewMenu';
import LanguageViewMenu from './LanguageViewMenu';
import { useAppDispatch } from '@wajeez-web/stores/base';
import { useAuthSelector } from '@wajeez-web/stores/auth';
import { CommonActions } from '@wajeez-web/stores/common';
import { Breadcrumbs } from '@wajeez-web/components/ui';

const NavBar = () => {
  const dispatch = useAppDispatch();
  const { role } = useAuthSelector((store) => store.auth);
  return (
    <div className="relative z-10 flex-shrink-0 flex xl:h-16 lg:h-14 md:h-12 bg-white shadow">
      <button
        className="px-4 border-e border-gray-200 text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500 md:hidden"
        onClick={() => dispatch(CommonActions.setNavBarCollapsed(true))}
      >
        <span className="sr-only">Open sidebar</span>
        <MenuAlt2Icon className="h-6 w-6" aria-hidden="true" />
      </button>
      <div className="flex-1 px-4 flex justify-between align-middle">
        <Breadcrumbs />
        <div className="flex-1 flex">
          <form className="w-full flex md:ms-0" action="#" method="GET">
            <label htmlFor="search_field" className="sr-only">
              Search
            </label>
          </form>
        </div>
        <div className="my-auto me-2">
          <LanguageViewMenu />
        </div>
        <div className="my-auto">
          {role?.includes('SuperAdmin') && <RoleViewMenu />}
        </div>
      </div>
    </div>
  );
};

export default NavBar;
